export var DebugSessionType;
(function (DebugSessionType) {
    DebugSessionType["CONTINUOUS"] = "CONTINUOUS";
    DebugSessionType["PLAIN"] = "MANUAL";
})(DebugSessionType || (DebugSessionType = {}));
//# sourceMappingURL=debugger-type.enum.js.map